import { render, staticRenderFns } from "./UnitPlanCalendar.vue?vue&type=template&id=9019984a&scoped=true&"
import script from "./UnitPlanCalendar.vue?vue&type=script&lang=js&"
export * from "./UnitPlanCalendar.vue?vue&type=script&lang=js&"
import style0 from "./UnitPlanCalendar.vue?vue&type=style&index=0&id=9019984a&lang=css&scoped=true&"
import style1 from "./UnitPlanCalendar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9019984a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/wbreu/Documents/code/personal/the-unit-planner/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9019984a', component.options)
    } else {
      api.reload('9019984a', component.options)
    }
    module.hot.accept("./UnitPlanCalendar.vue?vue&type=template&id=9019984a&scoped=true&", function () {
      api.rerender('9019984a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UnitPlanCalendar.vue"
export default component.exports